export default __webpack_public_path__ + "static/media/INJ.294f7646.svg";